import AOS from 'aos';
import scrollTo from 'animated-scroll-to';
import Rellax from 'rellax';
// import 'bootstrap/dist/js/bootstrap.esm.js';
import { Offcanvas, Modal } from 'bootstrap';
import {LuminousGallery } from 'luminous-lightbox'

window.addEventListener('load', function () {
  AOS.init({
    offset: 200,
    duration: 1000,
    easing: 'ease-out-back',
    delay: 0,
    once: true
  });
} );

window.addEventListener('load', function() {
  /**************************************************************
   * Bootstrap Modal - focus on first input
   **************************************************************/
  window.bootstrap = { Modal };

  const groups = {};
  document.querySelectorAll('.js-lightbox-item').forEach(a => {
    const key = a.dataset.gallery;
    if (!key) return;
    (groups[key] ||= []).push(a);
  });
  Object.entries(groups).forEach(([key, anchors]) => {
    // Crée la galerie lightbox
    const gallery = new LuminousGallery(anchors, {}, {
      caption: el => el.dataset.caption || ''
    });
  });

  /**************************************************************
   * Parallax on images
   **************************************************************/
  let rellax;
  if (document.querySelectorAll('.mix-blend img').length > 0)
    rellax = new Rellax('.mix-blend img', {center: true, speed: -7});
  /**************************************************************
   * Contact Accordion
   **************************************************************/
  const form = document.getElementById("contact");
  const nav = document.querySelector('#nav-main');
  const btns = document.getElementsByClassName("contact-btn");
  if (btns && form) {
    let formHeight = 0;
    for (let i = 0; i < form.children.length; i++) {
        formHeight += form.children[i].clientHeight;
    }
    //--- au clic sur un bouton contact
    for (let i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function(e) {
        e.preventDefault();
        if (form.clientHeight<10) {
          form.style.height = formHeight + 'px';
        }
        scrollTo(form.parentElement.parentElement, {verticalOffset: - (nav.clientHeight)});
      });
    }
    //--- si on arrive sur la page avec le #contact dans l'URL
    if (window.location.hash === '#contact')
      form.style.height = formHeight + 'px';
  }

  /**************************************************************
   * MENU - Scroll to Section
   **************************************************************/
  const links = document.querySelectorAll('.scroll-to a');
  if (links.length < 1) return;

  function scrollClick(e) {
    e.preventDefault();
    const elTo = document.querySelector(this.href.match(/(#\w+)/)[1]);
    const active = this.parentElement.parentElement.querySelector('.active');
    const bsOffcanvas = Offcanvas.getInstance(document.getElementById('offcanvasNavbar'));

    //--- si le mobile NAV n'est activé, il n'y a pas de bsOffcanvas
    //--- sinon c'est qu'il est ouvert et qu'on a cliqué sur un lien !
    if (bsOffcanvas)
      bsOffcanvas.hide();

    if (active)
      active.classList.remove('active');

    const navHeight = nav.clientHeight + 15;
    scrollTo(elTo, {verticalOffset: -navHeight});
    this.classList.add('active');
  }

  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener('click', scrollClick);
  }
});

window.addEventListener('load', function() {
  /**************************************************************
   * MENU - animation background on scroll
   **************************************************************/
  let nav = document.querySelector('#nav-main');
  let targetScroll = 200;
  let initY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  if( initY > targetScroll && nav.className.match('on-top') ) nav.classList.remove('on-top');

  function menuScroll() {
    if( !nav ) return;
    let scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if( scrollY > targetScroll && !nav.className.match('on-top') ) return;

    if( scrollY > targetScroll )
      nav.classList.remove('on-top');
    else
      nav.classList.add('on-top');
  }
  window.addEventListener('scroll', menuScroll);
});
